import { render, staticRenderFns } from "./ModalAddCategory.vue?vue&type=template&id=6c0a6364&"
import script from "./ModalAddCategory.vue?vue&type=script&lang=js&"
export * from "./ModalAddCategory.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddCategory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports